import { useCallback, useEffect, useRef, useState } from 'react';

import { isFavoritePage, subscribeFavorites, toggleFavorite } from './favorites-api';

export function useFavoriteBlock(blockId: string | null | undefined): {
  isFavorite: boolean;
  toggling: boolean;
  toggle: () => Promise<void>;
} {
  const [isFavorite, setIsFavorite] = useState(() =>
    blockId ? isFavoritePage(blockId) : false,
  );
  const [toggling, setToggling] = useState(false);
  const busy = useRef(false);

  useEffect(() => {
    if (!blockId) {
      setIsFavorite(false);
      return;
    }
    setIsFavorite(isFavoritePage(blockId));
    return subscribeFavorites(() => {
      setIsFavorite(isFavoritePage(blockId));
    });
  }, [blockId]);

  const toggle = useCallback(async () => {
    if (!blockId || busy.current) {
      return;
    }
    busy.current = true;
    setToggling(true);
    try {
      await toggleFavorite(blockId);
    } finally {
      busy.current = false;
      setToggling(false);
    }
  }, [blockId]);

  return { isFavorite, toggling, toggle };
}
